import Vuetify from "vuetify/lib/framework";

export const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#ff2d78",
        secondary: "#00092b",
      },
    },
  },
});
